import { DashboardFormWrapper } from '../../dashboard';
import { EmployeesPage } from './EmployeesComponents';
import { EmployeesAddHeader, EmployeesAddForm } from './EmployeesAddComponents';
import { RoleGuard } from '../../../routes';
import { useStoreUser } from '../../../context';
import { Roles } from '../../../types';

export const EmployeesAdd = () => {
  const { user } = useStoreUser();

  return (
    <RoleGuard
      roles={[
        'SUPER_ADMIN',
        'YARD_COMPANY_ADMIN',
        'YARD_MANAGER',
        'CLIENT_MANAGER',
        ...((user.yardEmployee?.canCreateClient ? ['YARD_DISPATCHER'] : []) as Roles[]),
      ]}
    >
      <RoleGuard roles={['TRADER']} isMobile negative>
        <EmployeesPage>
          <EmployeesAddHeader />
          <DashboardFormWrapper flow={'row'}>
            <EmployeesAddForm />
            <EmployeesAddHeader showOnlySubmit />
          </DashboardFormWrapper>
        </EmployeesPage>
      </RoleGuard>
    </RoleGuard>
  );
};
